export default "__VITE_ASSET__cPiQBN3a__"